import React, { useContext, useEffect, useState } from 'react'
import { ERROR_MESSAGES } from '../../Components/GlobalErrorMessage';
import dayjs from 'dayjs';
import { t } from 'i18next';
import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { LoaderContext } from '../../AuthContext/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetUserModel } from '../../ApiServices/Profile/ProfileApi';
import axios from 'axios';
import { handleProceedRemainingPayment } from '../../Components/RazorPay/RazorPayFunction';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import toast from 'react-hot-toast';

import { PujaBooking } from '../../ApiServices/Puja/PujaApi';
import { GetUserWalletAmount } from '../../ApiServices/UserWallet/UserWalletApi';
import Select from "react-select";
import { customSelectStyles, DurationLookupList } from '../../middlewares/Utils';
import { LanguageList } from '../../ApiServices/DailyPanditAPI/DailyPanditApi';
import { FaqModuleID } from '../../Components/enum';
import CouponModal from '../../Components/CouponModal';
import { CityLookupList, StateLookupList } from '../../ApiServices/Other/StateLookupListApi';
import { GetDurationDays } from '../../ApiServices/Other/DurationDaysApi';
import { AddUpdateProductBooking, GetDeliveryCharges, ProductDetailsBySlug } from '../../ApiServices/EStore/EStoreApi';


const ProductKitSubscriptionBooking = () => {
    const userID = localStorage.getItem("userID");
    const userKeyID = localStorage.getItem("userKeyID");
    const location = useLocation()
    const navigate = useNavigate()
    const { setLoader, formatToIndianCurrency, pujaStatus } = useContext(LoaderContext);

    const productDetailsData = location?.state?.productDetailsData;
    const [grandTotal, setGrandTotal] = useState(0)
    const [step, setStep] = useState(1);
    const [error, setError] = useState(false)
    const [showCODModal, setShowCODModal] = useState(null);


    const [availableWalletAmount, setAvailableWalletAmount] = useState(0)
    const [appliedCoupon, setAppliedCoupon] = useState({
        couponCode: null,
        isApplied: false,
        couponAmount: 0,
        walletAmount: 0,
        couponCodeID: null
    });
    const [isWalletApplied, setIsWalletApplied] = useState(false);
    const [isCouponApplied, setIsCouponApplied] = useState(false);
    const [deliveryChargesAmt, setDeliveryChargesAmt] = useState(0);
    const [modelRequestData, setModelRequestData] = useState({
        totalPrice: null,
        amountEntered: null,
        moduleName: null,
        couponCode: null
    });
    const [bookingFormData, setBookingData] = useState({
        fullName: null,
        address: null, mobileNumber: null,
        state: null, districtID: null, country: 1, landmark: null, pincode: null, stateID: null, countryName: "India"
    })

    const [bookingDetails, setBookingDetails] = useState(null)
    const [couponAmount, setCouponAmount] = useState(0)
    // -----------------------pandit booking parameters 

    const [daysList, setDaysList] = useState([]);
    const [languageOption, setLanguageOption] = useState([]);
    const [stateLookupList, setStateLookupList] = useState([]);
    const [cityLookupList, setCityLookupList] = useState([]);
    const [pujaTypeLookupList, setPujaTypeLookupList] = useState([{ value: 1, label: 'No' }, { value: 2, label: 'Yes' }]);
    const [showCouponModal, setShowCouponsModal] = useState(false)
    const [durationList, setDurationList] = useState(DurationLookupList);
    const [isGotraKnow, setsGotraKnown] = useState(false)
    const [selectedDays, setSelectedDays] = useState(null);


    const [canCalculateDays, setCalculationDays] = useState(false);
    const [couponObj, setCouponObj] = useState({
        userKeyID: userKeyID,
        pujaServiceID: null,
        pujaSubServiceID: null,
        orderAmount: 0

    })
    // -----------------------------------
    useEffect(() => {
        setGrandTotal(Math.round(productDetailsData?.discountedAmount))
        GetUserModelData()
        setBookingDetails(location?.state?.productDetailsData)
        GetUserWalletAmountData()
        GetStateLookupListData()
    }, [])

    useEffect(() => {

        if (isWalletApplied && isCouponApplied === false) {

            const price = Math.round(productDetailsData.discountedAmount || 0)
            const minAmount = Math.min(price, availableWalletAmount);
            const discountAmount = Math.round(minAmount * 0.5);
            setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
            setCouponAmount(discountAmount);


            // setCouponAmount(walletAmount)
        } else if (isWalletApplied === false && isCouponApplied === true) {
            setCouponAmount(appliedCoupon?.couponAmount)
        } else {
            setCouponAmount(0)
        }
    }, [isWalletApplied, isCouponApplied])

    useEffect(() => {
        TotalCalculations()

    }, [couponAmount, deliveryChargesAmt])

    useEffect(() => {

        if (bookingFormData?.stateID !== null && bookingFormData?.stateID !== undefined && bookingFormData?.stateID !== "" && bookingFormData?.districtID !== null && bookingFormData?.districtID !== undefined && bookingFormData?.districtID !== "") {
            GetDeliveryChargesLookupListData()
        }

    }, [bookingFormData])




    const TotalCalculations = () => {
        let productPrice = Math.round(productDetailsData.discountedAmount || 0)
        setGrandTotal((productPrice - couponAmount) + deliveryChargesAmt)
    }

    const GetDaysLookupListData = async () => {
        try {
            const response = await GetDurationDays(bookingFormData?.durationID); // Ensure it's correctly imported
            // const response = selectedDuration === 1 ? WeekDays : MonthDays

            if (response?.ResponseCode === "0") {
                const languageLookupList = response?.DATA || [];

                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.Days,
                    label: Lang.Days,
                    totalDays: Lang.TotalDays,
                }));
                setDaysList(formattedLangList);

            } else {
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            console.error("Error fetching sim Type lookup list:", error);
        }
    };

    const GetStateLookupListData = async () => {
        try {
            const response = await StateLookupList(1); // Ensure it's correctly imported

            if (response?.ResponseCode === "0") {
                const languageLookupList = response?.DATA || [];

                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.StateID,
                    label: Lang.StateName,
                }));

                setStateLookupList(formattedLangList);
            } else {
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            console.error("Error fetching sim Type lookup list:", error);
        }
    };
    const GetCityLookupListData = async (ID) => {
        try {
            const response = await CityLookupList(ID); // Ensure it's correctly imported

            if (response?.ResponseCode === "0") {
                const languageLookupList = response?.DATA || [];

                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.DistrictID,
                    label: Lang.DistrictName,
                }));

                setCityLookupList(formattedLangList);
            } else {
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            console.error("Error fetching sim Type lookup list:", error);
        }
    };

    const GetLanguageListLookupListData = async () => {
        setLoader(true);
        try {
            const response = await LanguageList(); // Ensure it's correctly imported

            if (response?.ResponseCode === "0") {
                setLoader(false);

                const languageLookupList = response?.DATA || [];
                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.LANG_ID,
                    label: Lang.LANG_NAME,
                }));

                setLanguageOption(formattedLangList);
            } else {
                setLoader(false);
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            setLoader(false);
            console.error("Error fetching sim Type lookup list:", error);
        }
    };

    const GetUserModelData = async () => {

        const userID = JSON.parse(localStorage.getItem("userID"));
        try {
            const response = await GetUserModel(userID);
            if (response?.ResponseCode == 0) {
                const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item

                setBookingData((prev) => ({
                    ...prev,

                    fullName: ModelData[0]?.FULL_NAME,
                    mobileNumber: ModelData[0]?.MOBILE_NO,

                }));
            } else {
                // setLoader(false);

                console.error(
                    "Error fetching data: ",
                    response?.data?.data?.statusCode
                );
            }
        } catch (error) {
            // setLoader(false);

            console.error("Error", error);
        }
    };

    const GetUserWalletAmountData = async () => {

        setLoader(true);
        try {
            let response = await GetUserWalletAmount(userKeyID); // Replace with actual import/function call
            if (response?.statusCode === 200) {
                setLoader(false);

                const list = response?.responseData?.data
                setAvailableWalletAmount(Number(list) <= 0 ? 0 : list)

            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };



    const handleChange = (e) => {
        let { id, value } = e.target;

        // ✅ Gotra, BirthPlace, Flat, Colony, Landmark formatting
        if (["gotra", "birthPlace", "flat", "colony", "landmark"].includes(id)) {
            value = value.replace(/^\s+/, ""); // remove leading spaces
            value = value.charAt(0).toUpperCase() + value.slice(1);
        }

        // ✅ Full name validation (only alphabets and spaces)
        if (id === "fullName") {
            value = value.replace(/^\s+/, ""); // no leading spaces
            value = value.replace(/[^a-zA-Z\s]/g, ""); // only letters and spaces
            value = value.charAt(0).toUpperCase() + value.slice(1);
        }

        // ✅ Mobile number validation (only digits, max length 10)
        if (id === "mobileNumber") {
            value = value.replace(/\D/g, ""); // only digits
            if (value.startsWith("0")) value = value.slice(1); // remove leading 0
            if (value.length > 10) value = value.slice(0, 10);
        }


        setBookingData((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleValidation = () => {

        let isValid = true
        if ((bookingFormData?.fullName === null || bookingFormData?.fullName === undefined || bookingFormData?.fullName === "" ||
            bookingFormData?.state === null || bookingFormData?.state === undefined || bookingFormData?.state === "" ||
            bookingFormData?.DistrictName === null || bookingFormData?.DistrictName === undefined || bookingFormData?.DistrictName === "" ||
            bookingFormData?.landmark === null || bookingFormData?.landmark === undefined || bookingFormData?.landmark === "" ||
            bookingFormData?.pincode === null || bookingFormData?.pincode === undefined || bookingFormData?.pincode === "" ||
            bookingFormData?.mobileNumber === null || bookingFormData?.mobileNumber === undefined || bookingFormData?.mobileNumber === "")

        ) {
            isValid = false;
            setError(true)
            return isValid
        } else { return true }

    }

    const handleRazorpayPayment = async () => {

        const isValid = handleValidation()

        if (isValid) {
            let orderIDReturned = null
            let minPayableAmount = modelRequestData.amountEntered
                ? modelRequestData.amountEntered
                : Math.round(grandTotal);
            setLoader(true)
            const orderAddress = `${bookingFormData?.state} ${bookingFormData?.colony} ${bookingFormData?.landmark} ${bookingFormData?.DistrictName} ${bookingFormData?.state} ${bookingFormData?.countryName} -${bookingFormData?.pincode}`
            const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)


            if (PlaceOrderResponse?.status === 1) {

                try {
                    const response = await AddUpdateProductBooking({
                        userKeyID: userKeyID,
                        orderAddress: orderAddress,

                        deliveryCharges: `${deliveryChargesAmt}`,
                        deliveryCharges: 100,
                        transactionAmount: grandTotal,
                        transactionID: PlaceOrderResponse?.razorpay_payment_id,
                        pSubPlanKeyID: bookingDetails?.pSubPlanKeyID,

                        paymentTypeID: 2,
                        couponCodeID: appliedCoupon?.couponCodeID,
                        couponCodeAmount: appliedCoupon?.CoupenAmount,
                        walletAmount: appliedCoupon?.walletAmount,
                        paymentStatus: true,
                        applicationType: "Website",
                        productType: "Product",

                    });

                    if (response?.statusCode === 200) {
                        setLoader(false);
                        setShowCODModal(false);


                        navigate("/thank-you", {
                            state: { moduleName: "Pujakit" },
                        });
                    } else {
                        setLoader(false);
                    }


                } catch (error) {
                    setLoader(false);
                    console.log(error);
                }
            } else if (PlaceOrderResponse?.status === 0) {
                setLoader(false)

            }
        }

    };

    const handleOpenCoupenModal = () => {
        setCouponObj((prev) => ({
            ...prev,
            userID: userID,
            pujaServiceID: productDetailsData?.pujaServiceID,
            pujaSubServiceID: productDetailsData?.pujaSubServiceID,
            orderAmount: bookingFormData?.pujaType === 1 ? (Math.round(productDetailsData.price - (productDetailsData.onlinePujaDiscountAmount || 0))) : (Math.round(productDetailsData.offlinePujaPrice - (productDetailsData.offlinePujaDiscountAmount || 0)))
        }))
        setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
        setShowCouponsModal(true)
    }

    const GetDeliveryChargesLookupListData = async () => {

        if (!bookingFormData?.districtID) {
            return;
        }
        try {
            const response = await GetDeliveryCharges(
                bookingFormData?.stateID,
                bookingFormData?.districtID
            );
            if (response?.ResponseCode === "0") {
                const CalculatedShippingCharges = response?.DATA[0].DeliveryCharges;
                setDeliveryChargesAmt(CalculatedShippingCharges);
                setModelRequestData((PREV) => ({
                    ...PREV,
                    totalVal: PREV.totalVal + CalculatedShippingCharges,
                }));

            } else {
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            console.error("Error fetching sim Type lookup list:", error);
        }
    };


    return (
        <>
            <div className="container my-5" style={{ display: "flex", flexDirection: "column" }}>

                <h4 className='text-center'>{productDetailsData?.pujaName} {t("Puja Booking Form")}</h4>
                {/* Step Content */}
                <div className=" p-4 shadow">
                    {step === 1 && (
                        <>
                            <div className="row">
                                {/* Left Side - Booking Form */}
                                <div className="col-md-8 col-sm-12 mb-3">
                                    <fieldset className="border rounded p-3">
                                        <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                                            {t("Booking Form")}
                                        </legend>
                                        <div className="row justify-content-left" style={{ justifyContent: "left" }}>
                                            {/* Full Name */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="fullName" style={{ textAlign: "left" }}>
                                                    {t("Full Name")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    id="fullName"
                                                    type="text"
                                                    className="custom-form-control"
                                                    value={bookingFormData.fullName || ""}
                                                    onChange={handleChange}
                                                    placeholder={t("Enter Full Name")}
                                                />
                                                {error && !bookingFormData.fullName && (
                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                )}
                                            </div>

                                            {/* Mobile Number */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label style={{ textAlign: "left" }}>
                                                    {t("Mobile Number")}
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id='mobileNumber'
                                                    className="custom-form-control rounded-3"
                                                    maxLength={10}
                                                    placeholder={t("Enter Mobile Number")}
                                                    value={bookingFormData.mobileNumber}
                                                    onChange={handleChange}
                                                />
                                                {(error && (!bookingFormData.mobileNumber || bookingFormData.mobileNumber === "")) && (
                                                    <span className="text-danger">{t("This field is required")}</span>
                                                )}
                                            </div>

                                            {/* State */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="stateID" style={{ textAlign: "left" }}>
                                                    {t("State")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    options={stateLookupList}
                                                    value={stateLookupList.find(
                                                        (item) => item.value === bookingFormData.stateID
                                                    )}
                                                    onChange={(selectedOption) => {
                                                        setBookingData((prev) => ({
                                                            ...prev,
                                                            stateID: selectedOption?.value,
                                                            state: selectedOption?.label,
                                                            districtID: null, // reset districtID when state changes
                                                        }));
                                                        GetCityLookupListData(selectedOption?.value);
                                                    }}
                                                    styles={customSelectStyles}
                                                />
                                                {error && !bookingFormData.stateID && (
                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                )}
                                            </div>

                                            {/* City */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="districtID" style={{ textAlign: "left" }}>
                                                    {t("City")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    options={cityLookupList}
                                                    value={cityLookupList.find(
                                                        (item) => item.value === bookingFormData.districtID
                                                    )}
                                                    onChange={(selectedOption) => {
                                                        setBookingData((prev) => ({
                                                            ...prev,
                                                            districtID: selectedOption?.value,
                                                            DistrictName: selectedOption?.label
                                                        }));

                                                    }}
                                                    styles={customSelectStyles}
                                                />
                                                {error && !bookingFormData.districtID && (
                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                )}
                                            </div>

                                            {/* Pincode */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="stateID" style={{ textAlign: "left" }}>
                                                    {t("Pincode")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="pincode"
                                                    placeholder="Pincode"
                                                    className="custom-form-control"
                                                    maxLength={6}
                                                    value={bookingFormData.pincode || ""}
                                                    onChange={(e) => {
                                                        const formattedInput = e.target.value.replace(/[^\d]/g, "");
                                                        setBookingData((prev) => ({
                                                            ...prev,
                                                            pincode: formattedInput,
                                                        }));
                                                    }}
                                                />
                                                {error && (!bookingFormData.pincode || bookingFormData.pincode.trim() === "") && (
                                                    <span className="text-danger" style={{ fontSize: "small" }}>
                                                        {ERROR_MESSAGES}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Flat / Building */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="flat" style={{ textAlign: "left" }}>
                                                    {t("Flat No.")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="flat"
                                                    placeholder="House No./Building No."
                                                    className="custom-form-control"
                                                    value={bookingFormData.flat || ""}
                                                    onChange={handleChange}
                                                />
                                                {error && (!bookingFormData.flat || bookingFormData.flat.trim() === "") && (
                                                    <span className="text-danger" style={{ fontSize: "small" }}>
                                                        {ERROR_MESSAGES}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Colony / Area */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="colony" style={{ textAlign: "left" }}>
                                                    {t("Colony / Area")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="colony"
                                                    placeholder="Road name/Area/Colony"
                                                    className="custom-form-control"
                                                    value={bookingFormData.colony || ""}
                                                    onChange={handleChange}
                                                />
                                                {error && (!bookingFormData.colony || bookingFormData.colony.trim() === "") && (
                                                    <span className="text-danger" style={{ fontSize: "small" }}>
                                                        {ERROR_MESSAGES}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Landmark */}
                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                <label htmlFor="landmark" style={{ textAlign: "left" }}>
                                                    {t("Landmark")}<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="landmark"
                                                    placeholder="Landmark"
                                                    className="custom-form-control"
                                                    value={bookingFormData.landmark || ""}
                                                    onChange={handleChange}
                                                />
                                                {error && (!bookingFormData.landmark || bookingFormData.landmark.trim() === "") && (
                                                    <span className="text-danger" style={{ fontSize: "small" }}>
                                                        {ERROR_MESSAGES}
                                                    </span>
                                                )}
                                            </div>





                                        </div>
                                    </fieldset>
                                </div>

                                {/* Right Side - Price Summary */}

                                <div className="col-md-4 col-sm-12 mb-3">
                                    <fieldset className="border rounded p-3">
                                        <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                                            {t("Payment Summary")}
                                        </legend>
                                        <div className='border rounded p-2 mb-2'>
                                            <ul className="list-unstyled mb-0">
                                                <li className="d-flex justify-content-between">
                                                    <span className=" payment-form-field">
                                                        {t("Kit Price")} (₹):
                                                    </span>
                                                    <span className=" payment-form-field">
                                                        {formatToIndianCurrency(Math.round(productDetailsData.discountedAmount || 0))
                                                        }

                                                    </span>
                                                </li>

                                                <li className="d-flex justify-content-between">
                                                    <span className=" payment-form-field">
                                                        {t("Delivery Charges")} (₹):
                                                    </span>
                                                    <span className=" payment-form-field">
                                                        {formatToIndianCurrency(Math.round(deliveryChargesAmt || 0))
                                                        }

                                                    </span>
                                                </li>


                                                {isWalletApplied && isCouponApplied === false ? (
                                                    <li className="d-flex justify-content-between">
                                                        <span className=" payment-form-field">
                                                            {t("Applied Wallet Amount")} (₹)

                                                        </span>
                                                        <span className=" payment-form-field">
                                                            {appliedCoupon?.walletAmount}
                                                        </span>
                                                    </li>
                                                ) : isWalletApplied === false && isCouponApplied ? (
                                                    <li className="d-flex justify-content-between">
                                                        <span className=" payment-form-field">
                                                            {t("Applied Coupon Amount")} (₹)

                                                        </span>

                                                        <span className=" payment-form-field">
                                                            {formatToIndianCurrency(couponAmount)}
                                                        </span>
                                                    </li>
                                                ) : ''}
                                                <hr />




                                                <li className="d-flex justify-content-between fw-bold">
                                                    <span className="payment-form-field">{t("Grand Total")} (₹):</span>
                                                    <span className="payment-form-field">
                                                        {formatToIndianCurrency(Math.round(grandTotal))}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className='border rounded p-2 mb-2'>
                                            {/* Wallet */}
                                            {availableWalletAmount !== 0 && (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-wallet2 fs-5 me-2 text-primary-custom"></i>
                                                            <div style={{ lineHeight: "1.2" }}>
                                                                <strong className="small" style={{ fontWeight: "600", color: "grey" }}>{t("Use Wallet Balance")}</strong><br />
                                                                <small className="text-muted">{t("Available")}: ₹ {isWalletApplied ? availableWalletAmount - appliedCoupon?.walletAmount : availableWalletAmount}</small>
                                                            </div>
                                                        </div>
                                                        {isWalletApplied ? (
                                                            <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {

                                                                setIsWalletApplied(!isWalletApplied)
                                                            }
                                                            }>{t("Remove Wallet")}</button>
                                                        ) : (
                                                            <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {
                                                                setAppliedCoupon((PREV) => ({
                                                                    ...PREV, couponCode: null,
                                                                    isApplied: false
                                                                }))
                                                                setIsWalletApplied(!isWalletApplied)
                                                                setIsCouponApplied(false)
                                                            }
                                                            }>{t("Apply Wallet")}</button>
                                                        )}

                                                    </div>
                                                    <div className="d-flex align-items-center mb-2" style={{ fontSize: "13px" }}>
                                                        <hr className="flex-grow-1 my-1" />
                                                        <span className="px-2 text-muted">{t("or")}</span>
                                                        <hr className="flex-grow-1 my-1" />
                                                    </div>
                                                </>

                                            )}


                                            {/* Coupons */}
                                            <div className="input-group input-group-sm mb-2 ">

                                                {isCouponApplied ? (
                                                    <div

                                                        style={{

                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            cursor: 'pointer',
                                                            // fontWeight: 'bold',
                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                                                            <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                                                            {appliedCoupon && (
                                                                <>
                                                                    <span
                                                                        style={{
                                                                            border: '1px dotted #333',
                                                                            padding: '2px 6px',
                                                                            borderRadius: '4px',
                                                                            fontSize: '12px',
                                                                            backgroundColor: '#fff',
                                                                            color: '#333',
                                                                            marginLeft: '6px',
                                                                        }}
                                                                    >
                                                                        {appliedCoupon?.couponCode}
                                                                    </span>

                                                                </>


                                                            )}
                                                        </div>
                                                        <span
                                                            onClick={() => {
                                                                setAppliedCoupon((prev) => ({
                                                                    ...prev, couponCode: null,
                                                                    isApplied: false,
                                                                    couponAmount: 0,
                                                                    walletAmount: 0
                                                                }))
                                                                setIsCouponApplied(false)
                                                            }}
                                                            style={{
                                                                // border: '1px dotted #333',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '12px',
                                                                backgroundColor: '#fff',
                                                                color: '#a52444',
                                                                marginLeft: '6px',
                                                            }} >



                                                            Remove

                                                        </span>
                                                        <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                                                    </div>
                                                ) : (
                                                    <div className='border border-1'
                                                        onClick={() => handleOpenCoupenModal()}
                                                        style={{

                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            cursor: 'pointer',
                                                            // fontWeight: 'bold',
                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                backgroundColor: '#a52444',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '24px',
                                                                height: '24px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '14px',
                                                                marginRight: '10px',

                                                            }}>
                                                                %
                                                            </div>
                                                            <span style={{ fontWeight: '400' }}>{t("View Coupons & Offers")}</span>

                                                        </div>
                                                        {/* <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span> */}
                                                    </div>
                                                )}

                                            </div>
                                            {/* <hr className="flex-grow-1 my-3" /> */}
                                        </div>




                                        <div className='text-left '>


                                            <button
                                                style={{ padding: "5px 16px", fontSize: "14px" }}
                                                className="Normal-app-btn"
                                                onClick={handleRazorpayPayment}
                                            >
                                                {t("Pay Now")}
                                            </button>
                                        </div>
                                    </fieldset>
                                    {/* Payment buttons  */}






                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <CouponModal
                show={showCouponModal}
                handleClose={() => setShowCouponsModal(false)}
                modelRequestData={modelRequestData}
                setAppliedCoupon={setAppliedCoupon}
                setIsWalletApplied={setIsWalletApplied}
                setIsCouponApplied={setIsCouponApplied}
                apiParam={couponObj} />

        </>
    )
}

export default ProductKitSubscriptionBooking
